export const LOADER_STATUS = 'boilderplate/Gstr6/isdDetails/LOADER_STATUS';
export const GSTN_INFO_DATA = 'boilderplate/Gstr6/isdDetails/GSTN_INFO_DATA';
export const HISTORY_TABLE_TOTAL_PAGES = 'boilderplate/Gstr6/isdDetails/HISTORY_TABLE_TOTAL_PAGES';

export const eligibilityOpts = [{
    label: "Eligible",
    value: "Eligible"
  },
  {
    label: "Ineligible",
    value: "Ineligible"
  }];